import React from "react";
import { PolicySequencesTab } from "../../../../../emailSequences/components/PolicySequencesTab";

/**
 * Habitational policy "Sequences" tab (PRD §5.5). Delegates to the shared
 * PolicySequencesTab, which reads the policy id from the Outlet context.
 */
export const HabitationalSequences: React.FC = () => <PolicySequencesTab />;
